export default __webpack_public_path__ + "static/media/relationships.45e57d02.svg";